import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { API_URL } from '../api-config';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PaginatedUserTable = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [usersPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${API_URL}/users/`, {
          headers: {
            Authorization: `Bearer ${token}`,
            accept: 'application/json',
          },
        });
        setUsers(response.data);
        setFilteredUsers(response.data);
      } catch (err) {
        setError('No se pudo cargar la lista de usuarios');
      }
    };

    fetchUsers();
  }, []);

  useEffect(() => {
    const filtered = users.filter((user) =>
      user.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredUsers(filtered);
    setCurrentPage(1);
  }, [searchTerm, users]);

  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  // Cambiar página
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="md:p-8 bg-slate-900 text-white">
      {/* Título */}
      <h2 className="text-3xl font-bold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-purple-200">
        Lista de Usuarios
      </h2>

      {/* Campo de búsqueda */}
      <div className="mb-6">
        <input
          type="text"
          placeholder="Buscar por nombre de usuario o email..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full px-4 py-2 rounded-lg bg-slate-700 text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
        />
      </div>

      {/* Mensaje de Error */}
      {error && (
        <div className="p-2 mb-4 text-sm text-red-300 bg-red-900/20 rounded">
          {error}
        </div>
      )}

        <button
          onClick={() => navigate('/search')}
          className="fixed top-6 left-6 z-20 bg-purple-600 text-white px-4 py-2 rounded-full hover:bg-purple-700 transition-all duration-300 shadow-lg 
                    sm:text-base text-sm sm:px-4 sm:py-2"
          aria-label="Volver a la página anterior"
        >
          {/* Icono */}
          <ArrowLeft className="w-5 h-5 inline-block mr-2 sm:mr-2" />
          <span className="hidden sm:inline">Volver</span>
        </button>

      {/* Tabla de Usuarios */}
      <div className="overflow-x-auto">
        <table className="min-w-full border rounded-lg shadow-md bg-slate-800 text-white">
          <thead>
            <tr>
              <th className="py-2 px-4 border-b border-purple-400 text-left md:text-center">ID</th>
              <th className="py-2 px-4 border-b border-purple-400 text-left md:text-center">Email</th>
              <th className="py-2 px-4 border-b border-purple-400 text-left md:text-center">Nombre de Usuario</th>
              <th className="py-2 px-4 border-b border-purple-400 text-left md:text-center">Nombre</th>
              <th className="py-2 px-4 border-b border-purple-400 text-left md:text-center">Apellido</th>
            </tr>
          </thead>
          <tbody>
            {currentUsers.map((user) => (
              <tr key={user.id} className="hover:bg-slate-700 transition-colors">
                <td className="py-2 px-4 border-b border-purple-400">
                  <Link to={`/users/info/${user.id}`} className="text-purple-400 hover:text-purple-300">
                    {user.id}
                  </Link>
                </td>
                <td className="py-2 px-4 border-b border-purple-400">
                  <Link to={`/users/info/${user.id}`} className="text-purple-400 hover:text-purple-300">
                    {user.email}
                  </Link>
                </td>
                <td className="py-2 px-4 border-b border-purple-400">
                  <Link to={`/users/info/${user.id}`} className="text-purple-400 hover:text-purple-300">
                    {user.username}
                  </Link>
                </td>
                <td className="py-2 px-4 border-b border-purple-400">{user.first_name || 'N/A'}</td>
                <td className="py-2 px-4 border-b border-purple-400">{user.last_name || 'N/A'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Paginación */}
      <div className="mt-6 flex justify-center">
        <Pagination
          usersPerPage={usersPerPage}
          totalUsers={filteredUsers.length}
          paginate={paginate}
        />
      </div>
    </div>
  );
};

const Pagination = ({ usersPerPage, totalUsers, paginate }) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalUsers / usersPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <nav>
      <ul className="flex space-x-2">
        {pageNumbers.map((number) => (
          <li key={number}>
            <button
              onClick={() => paginate(number)}
              className="px-4 py-2 text-white bg-purple-600 rounded-lg hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
            >
              {number}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default PaginatedUserTable;